/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 18:47:44
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-25 17:43:29
 * @Description:
 * @FilePath: /src/api/modules/order.js
 */
/**
 * 获取用户订单列表
 */
export const GET_ORDER_LIST = '/api/order/pagedQueryUserOrder';
/**
 * 获取订单详情
 */
export const GET_ORDER_INFO = '/api/order/detail';
/**
 * 获取订单券码
 */
export const GET_ORDER_COUPON = '/api/draw/listByOrderNo';
/**
 * 取消订单
 */
export const CANCEL_ORDER = '/api/order/movie/cancel/self';
/**
 * 获取订单未读消息
 */
export const GET_ORDER_UNREAD_MESSAGE = '/api/message/queryUnReadNum';
/**
 * 修改订单出票模式
 */
export const UPDATE_ORDER_DRAW_MODE = '/api/order/updateDrawMode';
/**
 * 通过订单编号获取订单详情
 */
export const GET_ORDER_INFO_FOR_ORDER_NO = '/api/order/getByOrderNo';
/**
 * 获取聊天记录
 */
export const GET_ORDER_MESSAGE_LIST = '/api/message/queryMessage';
/**
 * 修改下单手机号
 */
export const UPDATE_ORDER_USER_MOBILE = '/api/order/updateUserMobile';
/**
 * 修改订单是否接受调座
 */
export const UPDATE_ORDER_ACCEPT_ADJUST = '/admin/order/updateAcceptAdjust';
/**
 * 获取用户当前持有订单数量
 */
export const GET_USER_HOLD_ORDER_SEAT_COUNT = '/api/order/movie/getUserHoldOrderSeatCount';
/**
 * 获取手机号订单列表
 */
export const SMS_GET_ORDER_LIST = '/api/order/listByMobile';
/**
 * 提交0元订单
 */
export const SUBMIT_0_ORDER = '/api/order/movie/submit';
/**
 * 提交竞价订单
 */
export const SUBMIT_BID_ORDER = '/api/movieOrder/auction/startAuction';